import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "uxp-in-photoshop-vs-other-creative-cloud-applications"
    }}>{`UXP in Photoshop vs Other Creative Cloud Applications`}</h1>
    <p>{`As of this writing, the only other Creative Cloud application that supports UXP is `}<a parentName="p" {...{
        "href": "https://adobexdplatform.com"
      }}>{`Adobe XD`}</a>{`. Here are the main differences between UXP in Photoshop and UXP in XD.`}</p>
    <h2 {...{
      "id": "manifest-json"
    }}>{`Manifest JSON`}</h2>
    <p>{`The manifest.json file used in XD plugins before version 34 is version 3.x, which differs from the manifests used in Photoshop UXP (version 4.x and later) in a number of ways. In XD versions 35 and later, the manifest versions are the same.`}</p>
    <p>{`So if you have an XD plugin that you are porting to Photoshop, make sure to look at the current structure of the `}<a parentName="p" {...{
        "href": "/photoshop/uxp/guides/uxp_guide/uxp-misc/manifest-v4/"
      }}>{`manifest.json`}</a>{` file.`}</p>
    <h2 {...{
      "id": "host-application-api"
    }}>{`Host Application API`}</h2>
    <p>{`Obviously Photoshop and XD are very different applications and, as such, they expose very different DOMs and APIs. Additionally, Photoshop has a large number of different use cases, each with its own kind of objects and properties; it's a much more complex application than XD.`}</p>
    <p>{`As of this writing, the `}<a parentName="p" {...{
        "href": "/photoshop/uxp/guides/ps_basics/"
      }}>{`Photoshop API`}</a>{` is less mature than what's available in XD, but this is changing rapidly with each Photoshop release. Until the Photoshop API surface is complete for every object of interest, you can use an interface called `}<a parentName="p" {...{
        "href": "/photoshop/uxp/guides/ps_basics/batchplay_intro/"
      }}>{`batchPlay`}</a>{` to get to objects, properties, and actions that are not yet exposed to UXP directly.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      